<template>
	<nut-navbar
		class="navbar"
		title="滚动字幕制作"
		leftShow
		@on-click-back="goBack"
	>
		<template #right>
			<nut-icon
				@click="handleOpenDialog(SCROLL_SUBTITLE)"
				class-prefix="icon"
				font-class-name="iconfont"
				name="question-circle"
			></nut-icon>
		</template>
	</nut-navbar>
	<div class="form">
		<nut-textarea
			class="textarea"
			type="textarea"
			placeholder="请输入字幕内容"
			v-model="content"
			max-length="255"
			limit-show
		/>
		<!-- 暂时屏蔽该入口 -->
		<!-- <div class="select">
			<router-link to="/template">选择模版</router-link>
		</div> -->

		<!--<div class="form-item">-->
		<!--<span class="label">连播时长：</span>-->
		<!--<nut-input-->
		<!--class="input"-->
		<!--:border="false"-->
		<!--placeholder="请输入时长"-->
		<!--v-model="duration"-->
		<!--type="number"-->
		<!--/>-->
		<!--<span>分钟</span>-->
		<!--</div>-->
		<div class="form-item">
			<span class="label">字体颜色：</span>
			<div class="color-cell">
				<span
					class="color-tag"
					:style="{
						backgroundColor: color,
						color: color.indexOf('#000') > -1 ? '#fff' : '#000',
					}"
					@click="colorQuickSelectVisible = true"
				>
					{{ color }}
				</span>
				<span class="custom" @click="colorCustomSelectVisible = true">
					颜色自定义
				</span>
			</div>
		</div>
		<!--<div class="form-item">-->
		<!--<span class="label">滚动速度：</span>-->
		<!--<nut-inputnumber max="10" v-model="scrollSpeed" />-->
		<!--</div>-->
		<!--<div class="form-item form-item-between">-->
		<!--<span class="label">显示位置：</span>-->
		<!--<div class="content" @click="positionPickerShow = true">-->
		<!--<span>{{ selectedPositionText }}</span>-->
		<!--<nut-icon-->
		<!--size="10px"-->
		<!--name="right"-->
		<!--class-prefix="icon"-->
		<!--font-class-name="iconfont"-->
		<!--&gt;-->
		<!--</nut-icon>-->
		<!--</div>-->
		<!--</div>-->
		<!--<div class="form-item">-->
		<!--<span class="label">字体大小：</span>-->
		<!--<nut-inputnumber max="10" v-model="fontSize" />-->
		<!--</div>-->
		<div class="btn-container">
			<nut-button
				block
				type="primary"
				:disabled="!enable"
				@click="handleSaveSubtitle"
			>
				发布
			</nut-button>
		</div>
	</div>
	<nut-picker
		v-model="selectedPosition"
		v-model:visible="positionPickerShow"
		:columns="positionColumns"
		title="显示位置选择"
		@confirm="handlePositionConfirm"
	>
	</nut-picker>
	<!-- <nut-popup
		v-model:visible="colorQuickSelectVisible"
		position="bottom"
		round
		closeable
	>
		<div class="pop-title">颜色快捷选择</div>
		<div class="colors">
			<nut-radiogroup v-model="color" direction="horizontal">
				<nut-radio
					:label="color"
					:key="color"
					v-for="color in colorColumns"
				>
					<span
						class="color-item"
						:style="{
							background: color,
							border:
								color === '#FFFFFF'
									? '1px solid #e6e6e6'
									: 'none',
						}"
					></span>
				</nut-radio>
			</nut-radiogroup>
		</div>
	</nut-popup>
	<nut-popup v-model:visible="colorCustomSelectVisible" position="bottom">
		<color-picker style="width: 100%" v-model="color" />
	</nut-popup> -->
	<select-color
		v-model:colorQuickSelectVisible="colorQuickSelectVisible"
		v-model:colorCustomSelectVisible="colorCustomSelectVisible"
		v-model:color="color"
		:colorOptions="colorOptions"
	/>
</template>

<script>
import { ref, onMounted } from 'vue';
import { Toast } from '@nutui/nutui';
import { SelectColor } from '@/components';
import useNavigate from '@/hooks/useNavigate';
import useDialog from '@/hooks/useDialog';
import { SCROLL_SUBTITLE } from '@/constants/tiptype';
import { subtitleApi } from '@/apis';
import { positionColumns } from '@/constants/pickerColumns';

export default {
	name: 'Subtitle',
	components: {
		SelectColor,
	},
	setup() {
		const scrollSpeed = ref(1);
		const fontSize = ref(4);
		const content = ref('');
		const duration = ref('');
		const enable = ref(true); // 控制是否可以新增
		const colorOptions = ref([]); // 颜色值选项
		const { goBack, push } = useNavigate();
		const { handleOpenDialog } = useDialog();
		const color = ref('#FFFFFF'); // color-picker组件的v-model 返回的是{hex..}这个数据结构
		const colorQuickSelectVisible = ref(false); // 控制快速选择
		const colorCustomSelectVisible = ref(false); // 控制自定义选择
		// todo 待抽离
		const positionPickerShow = ref(false);
		const selectedPosition = ref(['bottom']);
		const selectedPositionText = ref('底部');

		const handlePositionConfirm = ({ selectedOptions }) => {
			selectedPositionText.value = selectedOptions[0].text;
		};

		const handleSaveSubtitle = async () => {
			if (!content.value) {
				return Toast.warn('内容不能为空');
				// Toast.warn('内容为空时，将撤销当前的字幕显示！');
			}
			// if (duration.value && Number(duration.value) > 24 * 60) {
			// 	return Toast.warn('暂不支持>24小时的连播！');
			// }
			await subtitleApi.subtitle_submit({
				subtitle: content.value,
				color: color.value,
				// duration: duration.value || 0,
				// speed: scrollSpeed.value,
				// location: selectedPosition.value[0],
				// size: fontSize.value,
			});
			Toast.success('发布成功', {
				duration: 1000,
				onClose() {
					push('/playlist');
				},
			});
		};
		// 获取subtitle默认配置
		const handleGetSubtitleConfig = async () => {
			const res = await subtitleApi.subtitle_load_data();
			colorOptions.value = res.color_options;
			color.value = res.color;
			content.value = res.subtitle;
			enable.value = res.enable;
		};

		onMounted(() => {
			handleGetSubtitleConfig();
		});

		return {
			SCROLL_SUBTITLE,
			content,
			duration,
			enable,
			scrollSpeed,
			fontSize,
			color,
			colorOptions,
			positionPickerShow,
			positionColumns,
			selectedPosition,
			selectedPositionText,
			colorQuickSelectVisible,
			colorCustomSelectVisible,
			goBack,
			handleOpenDialog,
			handlePositionConfirm,
			handleSaveSubtitle,
		};
	},
};
</script>

<style lang="scss" scoped>
// .select {
// 	text-align: right;
// 	padding: 15px;
// 	font-size: 14px;
// 	border-bottom: 1px solid #eaf0fb;
// 	a {
// 		color: $primary-color;
// 	}
// }

.textarea {
	:deep(.nut-textarea__textarea) {
		height: 180px !important;
	}
}
.form-item {
	border-bottom: 1px solid #eaf0fb;
	display: flex;
	align-items: center;
	padding: 15px;
	font-size: 13px;
	&-between {
		justify-content: space-between;
	}

	.color-cell {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.custom {
		color: #0096ff;
	}

	.input {
		flex: 1;
		padding: 0;
		line-height: 18px;
		font-size: 13px;
	}

	.content {
		display: flex;
		align-items: center;
		font-size: 12px;
		color: #999;
	}
}

.color-tag {
	display: inline-block;
	padding: 0 4px;
	height: 18px;
	line-height: 18px;
	font-size: $small-font-size;
}
</style>
